import "./working.css";
import WorkingSteps from "./workingSteps";
import ContactUsForm from "../../components/contactusproduct/contactusproduct";

const features = [
  { icon: '/assets/featurehighlights/OneToOne.png', title: '1. Lets Connect One To One' },
  { icon: '/assets/featurehighlights/ExploreCatalog.png', title: '2. Explore Our Catalog' },
  { icon: '/assets/featurehighlights/PlaceOrder.png', title: '3. Place Order' },
  { icon: '/assets/featurehighlights/DeliveryInstallation.png', title: '4. Delivery & Installation' },
  //{ icon: '/assets/featurehighlights/Continuous_Improvements.png', title: 'Continuous Improvements' },
];

const Working = () => {
  return (
    <div className="working-page">
      <div className="working-contact-background">
        <div>
          <ContactUsForm />
        </div>
      </div>

      <section className="working-highlights-section">
        <h2 className="working-highlights-header">
          Your Dream Project In 4 Steps
        </h2>
        <p className="working-highlight-text">
          Looking To Design Your Dream Art? We Create Beautiful Temples,
          Statues, And Art Just For You.
        </p>
        <div className="workings-container">
          {features.map((feature, index) => (
            <div className="working-feature" key={index}>
              <div className="working-item">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="working-icon"
                />
              </div>
              <p className="working-title">{feature.title}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="service-section">
        <h2 className="service-header">
          WE PROVIDE A COMPLETE, END-TO-END SERVICE, FROM CONCEPT TO
          COMPLETION.
        </h2>
        <p className="service-subtext">
          Our Experts will make the journey hassle-free
        </p>

        <div className="service-container">
          <div className="service-card">
            <img
              src="/assets/services/design.jpg"
              alt="We Design"
              className="service-image"
            />
            <h3 className="service-title">WE PLAN</h3>
            <p className="service-text">
              Create your ideal space with our expert designers, who will help
              you plan and picture your project.
            </p>
          </div>

          <div className="service-card">
            <img
              src="/assets/services/create.jpg"
              alt="We Create"
              className="service-image"
            />
            <h3 className="service-title">WE Build</h3>
            <p className="service-text">
              We build your dream space using the finest materials and precise
              craftsmanship so it will endure for years.
            </p>
          </div>

          <div className="service-card">
            <img
              src="/assets/services/install.jpg"
              alt="We Install"
              className="service-image"
            />
            <h3 className="service-title">WE INSTALL</h3>
            <p className="service-text">
              Get your project seamlessly delivered and installed, for a
              trouble-free and divine outcome.
            </p>
          </div>
        </div>
      </section>

      <div>
        <WorkingSteps />
      </div>
    </div>
  );
};

export default Working;
